import { ImpostoRendaState } from '../../types/state.types';
import { StoreAction } from '../reduxTypes';
import * as actions from './actions';

const initialState: ImpostoRendaState = {
  requisitado: false,
  filtros: {
    ano: "",
  },
  listaAnos: [],
  dadosIR: undefined,
  loading: false,
}

const  reducer = (
  state: ImpostoRendaState = initialState,
  action: StoreAction,
): ImpostoRendaState => {
  switch (action.type) {
    case actions.IMPOSTO_RENDA__INICIALIZA_ESTADO:
      return {
        ...state,
        requisitado: true,
      }

    case actions.IMPOSTO_RENDA__SET_ANOS:
      return {
        ...state,
        listaAnos: [
          ...action.payload
        ],
      }

    case actions.IMPOSTO_RENDA__SET_DADOS_IR:
      return {
        ...state,
        dadosIR: action.payload,
      }

    case actions.IMPOSTO_RENDA__SET_FILTROS:
      return {
        ...state,
        filtros: action.payload,
      }

    case actions.IMPOSTO_RENDA__LIMPAR_FILTROS:
      return {
        ...state,
        filtros: initialState.filtros,
      }

    case actions.IMPOSTO_RENDA__SET_LOADING:
      return {
        ...state,
        loading: action.payload,
        // dadosIR: initialState.dadosIR,
      }

    case 'SESSION__LOGOUT':
      return initialState;
  
    default:
      return state;
  }
}

export default reducer;
